import { render, staticRenderFns } from "./Lawsuits.vue?vue&type=template&id=27a5ab9a&scoped=true&"
import script from "./Lawsuits.vue?vue&type=script&lang=js&"
export * from "./Lawsuits.vue?vue&type=script&lang=js&"
import style0 from "./Lawsuits.vue?vue&type=style&index=0&id=27a5ab9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a5ab9a",
  null
  
)

export default component.exports